import GameSavannah from "./GameSavannah";

export default GameSavannah;
